import React from "react"
import ReduxProvider from "./src/redux/reduxProvider"

export const wrapRootElement = ({ element }) => {
  return <ReduxProvider>{element}</ReduxProvider>
}

